import React from 'react'
import { Switch, Route } from 'react-router-dom'

import NewDatabase from './New'
import InitialSetup from './InitialSetup'
import ViewSetup from './Views/Setup'
import Views from './Views'
import ViewList from './Views/List'
import ViewDetails from './Views/Details'
import NewView from './Views/New'
import EditView from './Views/Edit'

export default function Databases() {
  return (
    <Switch>
      <Route path="/databases/new" component={NewDatabase} />
      <Route path="/databases/initial-setup" component={InitialSetup} />
      <Route path="/databases/view-setup" component={ViewSetup} />
      <Route path="/databases/create-view" component={NewView} />
      <Route path="/databases/edit-view/:viewId" component={EditView} />
      <Route
        path="/databases/views/:viewId/records/:recordId"
        component={ViewDetails}
      />
      <Route path="/databases/views/:viewId" component={ViewList} />
      <Route component={Views} />
    </Switch>
  )
}
